import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AdminService } from "../../services/admin.service";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: 'app-create-game',
  templateUrl: './create-game.component.html',
  styleUrls: ['./create-game.component.scss']
})
export class CreateGameComponent {
  nationalGameForm: FormGroup;
  date = new Date();

  constructor(
    private fb: FormBuilder,
    private adminService: AdminService,
    public dialogRef: MatDialogRef<CreateGameComponent>
  ) {
    this.nationalGameForm = this.fb.group({
      homeTeam: ['', Validators.required],
      awayTeam: ['', Validators.required],
      leagueType: ['', Validators.required],
      status: ['', Validators.required],
      gameDate: ['', Validators.required],
      gameTime: ['', Validators.required]
    });
  }

  saveGame() {
    if (this.nationalGameForm.valid) {
      const formData = this.nationalGameForm.value;

      const date = formData.gameDate;
      const time = formData.gameTime;
      const dateTime = new Date(date);
      const [hours, minutes] = time.split(':').map(Number);
      dateTime.setHours(hours, minutes);

      const userTimezoneOffset = dateTime.getTimezoneOffset() * 60000;
      const localDateTime = new Date(dateTime.getTime() - userTimezoneOffset);

      const gameData = {
        ...formData,
        gameDate: localDateTime.toISOString(),
        homeTeamLogo: null,
        awayTeamLogo: null,
        homeTeamScore: 0,
        awayTeamScore: 0
      };

      this.adminService.createNationalGame(gameData).subscribe(() => {
        this.dialogRef.close(true);
      });
    }
  }


  cancel() {
    this.dialogRef.close();
  }
}
